module.exports = __webpack_public_path__ + "static/media/microscope.14ebb263.svg";